import { io } from 'socket.io-client';

const socketUrl = process.env.REACT_APP_SOCKET_URL;

let socketInstance = null;

export const createSocket = (options = {}) => {
  if (socketInstance) {
    return socketInstance;
  }

  const {
    ...restOptions
  } = options;

  socketInstance = io(socketUrl, {
    autoConnect: false,
    transports: ['websocket'],
    ...restOptions,
  });

  return socketInstance;
};

export const getSocket = () => {
  if (!socketInstance) {
    return createSocket();
  }

  return socketInstance;
};

export const connectSocket = (options = {}) => {
  const socket = createSocket(options);

  if (!socket.connected) {
    socket.connect();
  }

  return socket;
};

export const disconnectSocket = () => {
  if (!socketInstance) {
    return;
  }

  socketInstance.disconnect();
  socketInstance = null;
};

export const socketOn = (eventName, handler) => {
  const socket = getSocket();
  socket.on(eventName, handler);
  return () => socket.off(eventName, handler);
};

export const socketOnce = (eventName, handler) => {
  const socket = getSocket();
  socket.once(eventName, handler);
  return () => socket.off(eventName, handler);
};

export const socketOff = (eventName, handler) => {
  const socket = getSocket();
  socket.off(eventName, handler);
};

export const socketEmit = (eventName, payload, ack) => {
  const socket = getSocket();

  if (typeof ack === 'function') {
    socket.emit(eventName, payload, ack);
    return;
  }

  socket.emit(eventName, payload);
};
